import { useLocalStorage } from '@mantine/hooks'
import Field from 'components/Field'
import NumberInput from 'components/NumberInput'
import lodash from 'lodash'
import React, { useEffect } from 'react'
import { Menu } from 'semantic-ui-react'
import styled from 'styled-components'

import {
  Col,
  FormRow,
  Row,
} from '../../../../1stlog-ui/src/components/Bootstrap'
import { Label } from '../../../../1stlog-ui/src/components/Field'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import { Position } from '../../../../shipmetrics-shared/components/PrintFormatSelect'

const Form = (props) => {
  const { form, settings } = props

  const isLabelGroupAllowed = true // userModules.includes("print_format_labelgroup")

  const [format, setFormat] = useLocalStorage({
    key: 'printFormat',
    defaultValue: {
      format: 'label',
    },
  })

  const changeFormat = (value) => {
    setFormat({ format: value })
  }

  const [position, setPosition] = useLocalStorage({
    key: 'printFormatPosition',
    defaultValue: 0,
  })

  useEffect(() => {
    form.batch(() => {
      lodash.forEach(settings, (value, key) => {
        form.change(key, value)
      })
    })
  }, [])

  return (
    <div className="p-2">
      <FormRow>
        <Col>
          <Field
            name="loginTimeout"
            label={i18n.t(
              'automatic_logout_in_minutes',
              'Automatischer Logout (in Minuten)',
            )}
          >
            <NumberInput min={0} max={99999} hideButtons block />
          </Field>
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Label>
            {i18n.t(
              'label_print_default_format',
              'Standardformat für Labeldruck',
            )}
          </Label>
          <div className="mt-1">
            <div className="d-flex">
              <Menu compact icon="labeled" widths={3}>
                <Menu.Item
                  active={format.format === 'A4'}
                  onClick={() => changeFormat('A4')}
                >
                  <Icon size={1.2} icon="far fa-file" className="mb-1" />
                  DIN-A4
                </Menu.Item>

                <Menu.Item
                  active={format.format === 'label'}
                  onClick={() => changeFormat('label')}
                >
                  <Icon size={1.2} icon="far fa-image" className="mb-1" />
                  {i18n.t('label', 'Label')}
                </Menu.Item>

                {isLabelGroupAllowed && (
                  <Menu.Item
                    active={format.format === 'labelgroup'}
                    onClick={() => changeFormat('labelgroup')}
                  >
                    <Icon
                      size={1.2}
                      icon="far fa-game-board-alt"
                      className="mb-1"
                    />
                    {i18n.t('label_group', 'Labelgruppe')}
                  </Menu.Item>
                )}
              </Menu>
            </div>
          </div>
        </Col>
      </FormRow>
      {format.format === 'labelgroup' && (
        <FormRow className="mt-2">
          <Col>
            <Label>
              {i18n.t(
                `label_print_default_start_position`,
                `Standardposition für den Labeldrucker`,
              )}
            </Label>
            <div className="px-2 py-1">
              {lodash.map(
                lodash.chunk(Array.from(Array(4).keys()), 2),
                (chunk) => {
                  return (
                    <Row>
                      {lodash.map(chunk, (index) => (
                        <Position
                          onClick={() => setPosition(index)}
                          active={position === index}
                          className=" text-center"
                          style={{ fontSize: '2rem' }}
                        >
                          <span className="mx-auto my-auto text-dark">
                            {index + 1}
                          </span>
                        </Position>
                      ))}
                    </Row>
                  )
                },
              )}
            </div>
          </Col>
        </FormRow>
      )}
    </div>
  )
}

export default Form
